import type { WorkspaceBillingActivityType } from '@nest-react/domain';

const supported: WorkspaceBillingActivityType[] = [
  'GENERATION',
  'TOP_UP',
  'PLAN_GRANT',
  'CARRYOVER',
  'PROMOTION',
  'REFUND',
  'ADMIN_ADJUSTMENT',
  'EXPIRY',
  'OTHER',
];

export const readBillingActivityState = (
  search: string
): {
  type: WorkspaceBillingActivityType | null;
  cursor: string | null;
  invalidType: boolean;
} => {
  const params = new URLSearchParams(search);
  const rawType = params.get('activityType');
  const type = supported.includes(rawType as WorkspaceBillingActivityType)
    ? (rawType as WorkspaceBillingActivityType)
    : null;
  return {
    type,
    cursor: type || !rawType ? params.get('activityCursor') : null,
    invalidType: Boolean(rawType && !type),
  };
};

const stringify = (params: URLSearchParams): string => {
  const value = params.toString();
  return value ? `?${value}` : '';
};

export const setBillingActivityType = (
  search: string,
  type: WorkspaceBillingActivityType | null
): string => {
  const params = new URLSearchParams(search);
  if (type) params.set('activityType', type);
  else params.delete('activityType');
  params.delete('activityCursor');
  return stringify(params);
};

export const setBillingActivityCursor = (
  search: string,
  cursor: string | null
): string => {
  const params = new URLSearchParams(search);
  if (cursor) params.set('activityCursor', cursor);
  else params.delete('activityCursor');
  return stringify(params);
};
